class ProcessButton{
    constructor(state, idProceso, srcActive, srcInactive, srcHover){
        this.state = state;
        this.idProceso = idProceso;
        this.srcActive = srcActive;
        this.srcHover = srcHover;
        this.srcInactive = srcInactive;
    }
}

export default ProcessButton;